import { useState } from "react";
import { Modal, Typography, Space, Button, message } from "antd";
import { useMutation } from "@apollo/client";
import { DELETE_PRODUCT } from "./requests";
import { productTypes } from "../../../../types";

const { Text } = Typography;

interface DeleteProductProps {
  product: typeof productTypes.product | null;
  setProduct: (product: typeof productTypes.product | null) => void;
  refetch: () => void;
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function DeleteProduct({ product, setProduct, refetch, open, setOpen }: DeleteProductProps) {
  const [confirmLoading, setConfirmLoading] = useState(false);

  const [deleteProduct] = useMutation(DELETE_PRODUCT);

  const handleDelete = async () => {
    setConfirmLoading(true);
    try {
      await deleteProduct({ variables: { id: product?.id } });
      setOpen(false);
      await refetch();
      message.success("Producto y sus variantes eliminados");
    } catch (error) {
      console.log(error);
      message.error("Hubo un error.");
    } finally {
      setConfirmLoading(false);
    }
  };

  const onClose = ()=>{
    setOpen(false);
    setProduct(null);
  }

  return (
    <Modal
      title="Confirmación de Eliminación"
      open={open}
      onCancel={onClose}
      footer={null}
    >
      <Text strong>
        ¿Estás seguro de que deseas eliminar este producto? Esta acción también eliminará todas sus variantes asociadas.
      </Text>

      <div style={{ marginTop: 24,
        textAlign: "right" }}>
        <Space>
          <Button onClick={onClose}>Cancelar</Button>
          <Button
            type="primary"
            danger
            loading={confirmLoading}
            onClick={handleDelete}
          >
            Sí, eliminar
          </Button>
        </Space>
      </div>
    </Modal>
  );
}
